<div class="privacy">
  <h1>{{ "PRIVACY.TITLE" | translate }}</h1>

  <p>
    <strong>{{ "PRIVACY.RESPONSIBLE" | translate }}</strong
    ><br />
    Jonas Valtin<br />
    j.valtin&#64;online.de
  </p>

  <div class="privacy-container">
    <h2>{{ "PRIVACY.GENERAL_TITLE" | translate }}</h2>
    <p>{{ "PRIVACY.GENERAL_TEXT" | translate }}</p>
  </div>

  <div class="privacy-container">
    <h2>{{ "PRIVACY.CONTACTFORM_TITLE" | translate }}</h2>
    <p>{{ "PRIVACY.CONTACTFORM_TEXT" | translate }}</p>
  </div>

  <div class="privacy-container">
    <h2>{{ "PRIVACY.HOSTING_TITLE" | translate }}</h2>
    <p [innerHTML]="'PRIVACY.HOSTING_TEXT1' | translate"></p>
    <p>{{ "PRIVACY.HOSTING_TEXT2" | translate }}</p>
  </div>

  <div class="privacy-container">
    <h2>{{ "PRIVACY.NO_COOKIES_TITLE" | translate }}</h2>
    <p [innerHTML]="'PRIVACY.NO_COOKIES_TEXT' | translate"></p>
  </div>

  <div class="privacy-container">
    <h2>{{ "PRIVACY.EXTERNAL_LINKS_TITLE" | translate }}</h2>
    <p [innerHTML]="'PRIVACY.EXTERNAL_LINKS_TEXT' | translate"></p>
  </div>

  <div class="privacy-container">
    <h2>{{ "PRIVACY.LOGFILES_TITLE" | translate }}</h2>
    <p>{{ "PRIVACY.LOGFILES_TEXT" | translate }}</p>
  </div>

  <div class="privacy-container">
    <h2>{{ "PRIVACY.RIGHTS_TITLE" | translate }}</h2>
    <p>{{ "PRIVACY.RIGHTS_TEXT1" | translate }}</p>
    <p>{{ "PRIVACY.RIGHTS_TEXT2" | translate }}</p>
  </div>
</div>
